import React, { createContext, useContext, useState } from "react";
import { io, Socket } from "socket.io-client";

const SOCKET_SERVER_URL = process.env.REACT_APP_API_BASE_URL || ""; // safe fallback

interface ISocketContext {
  socket: Socket | null;
  connectSocket: (token: string) => void;
}

const SocketContext = createContext<ISocketContext>({
  socket: null,
  connectSocket: () => {},
});

export const useSocket = () => useContext(SocketContext);

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [socket, setSocket] = useState<Socket | null>(null);

  const connectSocket = (token: string) => {
    if (socket) return; // already connected

    const newSocket = io(SOCKET_SERVER_URL, {
      transports: ["websocket"],
      auth: { token }, // pass JWT token here
    });

    setSocket(newSocket);

    newSocket.on("connect", () => {
      console.log("Socket connected:", newSocket.id);
    });

    newSocket.on("connect_error", (err) => {
      console.error("Socket connection error:", err.message);
    });

    newSocket.on("disconnect", () => {
      console.log("Socket disconnected");
    });
  };

  return (
    <SocketContext.Provider value={{ socket, connectSocket }}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketContext;
